<!-- ######################################################################
#
# The Main Navigation Bar
#
###################################################################### -->

<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark" class="navbar-my">

      <b-navbar-brand href="#">
        <img height="40" src="/img/logo-dark.png" alt="Brand Logo">
      </b-navbar-brand>
  
      <!-- Default Bootstrap Toggler -->
      <button 
        type="button" 
        aria-label="Toggle navigation" 
        class="navbar-toggler collapsed" 
        :aria-expanded="isMenuCollapsed" 
        aria-controls="nav-collapse" 
        @click="toggleMenu"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <b-collapse id="nav-collapse" is-nav v-model="isMenuCollapsed">

        <b-navbar-nav class="align-items-center">
          <base-button outline v-if="activeEntity" type="info" @click="onEntityClick">{{activeEntity}}</base-button>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="align-items-center ml-auto">

          <!-- MAIN MENU ###################################################################### -->

          <b-nav-item to="/entity" v-if="rights.landlord">
            <span class="nav-link-inner--text text-white">Entities</span>
          </b-nav-item>

          <b-nav-item to="/saccounts" v-if="rights.landlord">
            <span class="nav-link-inner--text text-white">Accounts</span>
          </b-nav-item>

          <b-nav-item to="/sdevices" v-if="rights.landlord">
            <span class="nav-link-inner--text text-white">Devices</span>
          </b-nav-item>
          
          <b-nav-item to="/sDataview" v-if="rights.landlord">
            <span class="nav-link-inner--text text-white">Dataviews</span>
          </b-nav-item>

          <b-nav-item :to="{ name: Routes.accountList }" v-if="!rights.landlord">
            <span class="nav-link-inner--text text-white">Accounts</span>
          </b-nav-item>

          <b-nav-item :to="{ name: Routes.appList }" v-if="!rights.landlord">
            <span class="nav-link-inner--text text-white">Dataviews</span>
          </b-nav-item>

          <b-nav-item :to="{ name: Routes.siteList }" v-if="!rights.landlord">
            <span class="nav-link-inner--text text-white">Sites</span>
          </b-nav-item>

          <!--b-nav-item :to="{ name: Routes.kioskList }" v-if="!rights.landlord">
            <span class="nav-link-inner--text text-white">Kiosks</span>
          </b-nav-item>-->

          <b-nav-item :to="{ name: Routes.dispenserList }" v-if="!rights.landlord">
            <span class="nav-link-inner--text text-white">Groups</span>
          </b-nav-item>

          <b-nav-item :to="{ name: Routes.deviceList }" v-if="!rights.landlord">
            <span class="nav-link-inner--text text-white">Devices</span>
          </b-nav-item>
          
          <b-nav-item to="/apps" v-if="!rights.landlord">
            <span class="nav-link-inner--text text-white">Apps</span>
          </b-nav-item>

          <!-- ACCOUNT ###################################################################### -->

         <base-dropdown menu-on-right
                 class="nav-item"
                 tag="li"
                 title-tag="a"
                 title-classes="nav-link pr-0">

    <!-- 🔧 Replace @click.prevent.stop with a custom handler -->
    <a href="#" class="nav-link pr-0" @click.prevent="handleAccountClick" slot="title-container">
      <b-media no-body class="align-items-center">
        <span class="avatar avatar-sm rounded-circle bg-primary">{{usernameShort}}</span>
        <b-media-body class="ml-2 d-none d-lg-block">
          <span class="mb-0 text-sm  font-weight-bold text-white">{{username}}</span>
        </b-media-body>
      </b-media>
    </a>


            <template>

              <b-dropdown-item to="/settings">
                <i class="ni ni-settings-gear-65"></i>
                <span>Settings</span>
              </b-dropdown-item>
              <b-dropdown-item to="/schedules" v-if="!rights.landlord">
                <i class="ni ni-calendar-grid-58"></i>
                <span>Schedules</span>
              </b-dropdown-item>
              <b-dropdown-item @click="toggleDarkMode" class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="ni ni-palette mr-2"></i>
                  <span>Dark Mode</span>
                </div>
              </b-dropdown-item>

              <b-dropdown-divider/>

              <b-dropdown-item href="#!" @click='onLogout'>
                <i class="ni ni-user-run"></i>
                <span>Logout</span>
              </b-dropdown-item>

            </template>

          </base-dropdown>

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<!-- ###################################################################### -->

<script>
import {Action} from "@/store/actions";
import {mapGetters} from "vuex";
import {mapState} from "vuex";
import {Routes} from "@/router";

export default {
  name: "MainNav",
  data() {
    return {
      Routes: Routes,
      isMenuCollapsed: false,
         keepMenuOpen: false, 
    };
  },
  methods: {
      handleAccountClick() {
      // Signal that the next collapse should not stay closed
      this.keepMenuOpen = true;
      // The dropdown toggles because the event is allowed to bubble
    },
    toggleMenu() {
      this.isMenuCollapsed = !this.isMenuCollapsed;
    },
    onLogout() {
      this.$store.dispatch(Action.auth.logout).then(() => {
        this.$router.push({name: Routes.authLogin});
      });
    },
    onEntityClick() {
      if(this.$route.name !== Routes.entityEdit) {
        this.$router.push({name: Routes.entityEdit});
      }
    },
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
      this.$parent.$emit('toggle-dark-mode', this.darkMode);
      localStorage.setItem('darkMode', this.darkMode);
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'username', 'usernameShort', 'activeEntity']),
    ...mapState({
      rights: state => state.auth.rights,
    }),
  },
    watch: {
    isMenuCollapsed(newVal) {
      // If the menu was collapsed but we just clicked the account icon,
      // immediately re-open it and clear the flag.
      if (!newVal && this.keepMenuOpen) {
        this.$nextTick(() => {
          this.isMenuCollapsed = true;
          this.keepMenuOpen = false;
        });
      }
    },
  },
  created() {
    this.darkMode = localStorage.getItem('darkMode') === 'true';
    this.$parent.$emit('toggle-dark-mode', this.darkMode);
  }
}
</script>

<!-- ###################################################################### -->

<style lang="scss">
.active {
  font-weight: bold !important;
}

.navbar-my {
  position: fixed !important;
  top: 0;
  width: 100%;
  z-index: 100;
  border-bottom: 1px solid #00000055 !important;
}

.theme-toggle-mini {
  cursor: pointer;
  user-select: none;
}

.toggle-container-mini {
  width: 40px;
  height: 20px;
  border-radius: 10px;
  position: relative;
  transition: background-color 0.3s ease;
  background-color: #6c757d;

  &.active {
    background-color: #11CDEF;
  }
}

.toggle-slider-mini {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &.active {
    transform: translateX(20px);
    background-color: #444;
  }
}

.icon-mini {
  font-size: 10px;
  color: inherit;
}

.icon-mini.sun {
  color: #f39c12;
}

.icon-mini.moon {
  color: #2c3e50;
}
</style>